// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import ImageSource from './ImageSource.view';
import ImageTag from './ImageTag.view';
import { getImageStyle } from '../DamImage.styles';

export const getPictureBlockV2 = ({
  imageSourcesV2,
  preloadImage,
  imgSrc,
  alt,
  primaryBrand,
  imgData,
  className,
  tabIndex,
  onLoad,
  isProductImage,
  lazyLoadImage,
  isDamImageV2EnabledPLP,
  imageSourcesV2WithoutDPR,
  fromBagPage,
  imgSrcCart,
  imageSourcesV2Cart,
}) => {
  if (isDamImageV2EnabledPLP) {
    return (
      <picture>
        <ImageSource
          srcSet={imageSourcesV2.tablet}
          media="(min-width: 0px)"
          preloadImage={preloadImage}
          srcSetWithoutDPR={imageSourcesV2WithoutDPR?.tablet || []}
        />
        <ImageTag
          src={imgSrc.url}
          crop={imgSrc.crop}
          altText={alt}
          overrideStyle={getImageStyle(imgData)}
          className={className}
          primaryBrand={primaryBrand}
          tabIndex={tabIndex}
          onLoad={onLoad}
          backgroundStyle={imgData.backGroundStyle}
          isProductImage={isProductImage}
          lazyLoadImage={lazyLoadImage}
        />
      </picture>
    );
  }
  return (
    <picture>
      <ImageSource
        srcSet={imageSourcesV2.desktop}
        srcSetCart={fromBagPage && imageSourcesV2Cart?.desktop}
        fromBagPage={fromBagPage}
        media="(min-width: 768px)"
        preloadImage={preloadImage}
        srcSetWithoutDPR={imageSourcesV2WithoutDPR?.desktop || []}
      />
      <ImageSource
        srcSet={imageSourcesV2.mobile}
        srcSetCart={fromBagPage && imageSourcesV2Cart?.mobile}
        fromBagPage={fromBagPage}
        media="(max-width: 767px)"
        preloadImage={preloadImage}
        srcSetWithoutDPR={imageSourcesV2WithoutDPR?.mobile || []}
      />

      <ImageTag
        src={imgSrc.url}
        crop={imgSrc.crop}
        fromBagPage={fromBagPage}
        srcCart={fromBagPage && imgSrcCart.url}
        cropCart={fromBagPage && imgSrcCart.crop}
        altText={alt}
        overrideStyle={getImageStyle(imgData)}
        className={className}
        primaryBrand={primaryBrand}
        tabIndex={tabIndex}
        onLoad={onLoad}
        backgroundStyle={imgData.backGroundStyle}
        isProductImage={isProductImage}
        lazyLoadImage={lazyLoadImage}
      />
    </picture>
  );
};

export default getPictureBlockV2;
